import type { FC } from 'react';
import type { DocketTimelineTabProps } from './DocketTimelineTab.types';

import { DocumentTimeline, DOCUMENT_TIMELINE_TYPE } from '../../../../../../../DocumentTimeline';

export const DocketTimelineTab: FC<DocketTimelineTabProps> = ({ document }) => {
  return <DocumentTimeline type={DOCUMENT_TIMELINE_TYPE.DOCKET} document={document} />;
};
